// Section wrappers for the public venue page. Mobile uses a full-bleed 4px divider
// band (Figma: 36px above via the previous section's margin, 24px below), desktop
// keeps the hairline top border.
export const SECTION_WRAPPER_DESKTOP = "mb-8 border-t border-[#EFEFEF] pt-6"

export const SECTION_WRAPPER_MOBILE =
  "relative mb-9 pt-6 before:absolute before:-left-4 before:-right-4 before:top-0 before:h-1 before:bg-[#ededed] before:content-['']"

export const SECTION_WRAPPER_MOBILE_NO_DIVIDER = "mb-9"

export const publicSectionClasses = (isMobile: boolean, showDivider: boolean = true) => {
  if (!isMobile) return SECTION_WRAPPER_DESKTOP
  return showDivider ? SECTION_WRAPPER_MOBILE : SECTION_WRAPPER_MOBILE_NO_DIVIDER
}
